import { Center, Image, Stack, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const ErrorScreen = () => {
  const { t } = useTranslation();

  return (
    <Center data-test-id="global-error-screen" h="100dvh" px={24}>
      <Stack align="center" gap={8}>
        <Image
          alt="Error Icon"
          data-test-id="global-error-icon"
          h={64}
          src="./error-icon.svg"
          w={64}
        />
        <Title
          className="text-red-500"
          data-test-id="global-error-message"
          fw={500}
          size={14}
          ta="center"
        >
          {t('Global.errorWhileLoading')}
        </Title>
      </Stack>
    </Center>
  );
};
